require('./bootstrap');
import { equalheight } from './modules/helpers';
import Swiper, {Autoplay, Navigation}  from 'swiper';
Swiper.use([Autoplay, Navigation]);

new Swiper(".carrusel > .swiper", {
    loop: true,
    spaceBetween: 0,
    autoplay: {
        delay: 7000,
        disableOnInteraction: false
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
});

// let bloques = document.querySelectorAll(".bloque-grupo");
//
// bloques.forEach((el) => {
//     let carrusel = el.querySelector(".swiper");
//
//     new Swiper(carrusel, {
//         grabCursor: true,
//         slidesPerView: 1,
//         spaceBetween: 0,
//         slidesPerGroup: 1,
//         breakpoints: {
//             400: {
//                 slidesPerView: 2,
//                 spaceBetween: 5,
//                 slidesPerGroup: 10,
//             },
//             768: {
//                 slidesPerView: 3,
//                 spaceBetween: 10,
//                 slidesPerGroup: 3,
//             },
//             1280: {
//                 slidesPerView: 6,
//                 spaceBetween: 20,
//                 slidesPerGroup: 6,
//             },
//         },
//         navigation: {
//             nextEl: carrusel.parentElement.querySelector(".swiper-button-next"),
//             prevEl: carrusel.parentElement.querySelector(".swiper-button-prev")
//         },
//         on: {
//             afterInit: function () {
//                 equalheight(el.querySelectorAll(".producto"))
//             },
//             beforeResize: function () {
//                 equalheight(el.querySelectorAll(".producto"))
//             }
//         }
//     });
//
//
// })
